import {Component, Inject, OnInit} from '@angular/core';
import {TestLinkService} from '../../../services/api/test-link.service';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TEST_LINK_VALIDATORS} from '../../../../constants/validators';
import {formatDate} from '@angular/common';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-test-link-create-dialog',
  templateUrl: './test-link-create-dialog.component.html',
  styleUrls: ['./test-link-create-dialog.component.css']
})
export class TestLinkCreateDialogComponent implements OnInit {

  today: Date;

  testLinkForm = this.fb.group({
    name: ['Ссылка по умолчанию', TEST_LINK_VALIDATORS.NAME],
    mail: ['', TEST_LINK_VALIDATORS.MAIL],
    startDate: [formatDate(new Date(), 'yyyy-MM-dd', 'ru'), TEST_LINK_VALIDATORS.START_DATE],
    finishDate: ['', TEST_LINK_VALIDATORS.FINISH_DATE],
    isMixedQuestions: [false, Boolean],
    isMixedOptions: [false, Boolean],
    allQuestionsRequired: [true, Boolean],
    trackTelegramUsers: [false, Boolean],
  });

  isFinishless = true;
  testId: number;
  testType: string;

  constructor(
    private testLinkService: TestLinkService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TestLinkCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { testId: number, testType: string },
  ) {
    this.today = new Date();
    this.today.setHours(0);
    this.today.setMinutes(0);
    this.today.setSeconds(0);
    this.today.setMilliseconds(0);
    this.testId = this.data.testId;
    this.testType = this.data.testType;
    this.setFinishless(true);

    if (this.testType == 'ISTQB') {
        this.testLinkForm.controls.isMixedQuestions.setValue(true);
        this.testLinkForm.controls.isMixedOptions.setValue(true);
    }
  }

  ngOnInit(): void {
  }

  setFinishless(isFinishless: boolean): void {
    this.isFinishless = isFinishless;
    if (isFinishless) {
      this.testLinkForm.controls.finishDate.setValue('9999-12-31');
      this.testLinkForm.controls.finishDate.disable();
    } else {
      this.testLinkForm.controls.finishDate.setValue(this.testLinkForm.controls.startDate.value);
      this.testLinkForm.controls.finishDate.enable();
    }
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.testLinkForm.valid) {
      this.testLinkService.addTestLink(this.testId, {
        name: this.testLinkForm.controls.name.value,
        mail: this.testLinkForm.controls.mail.value,
        startDate: formatDate(this.testLinkForm.controls.startDate.value, 'yyyy-MM-dd', 'ru'),
        finishDate: formatDate(this.testLinkForm.controls.finishDate.value, 'yyyy-MM-dd', 'ru'),
        isMixedQuestions: this.testLinkForm.controls.isMixedQuestions.value,
        isMixedOptions: this.testLinkForm.controls.isMixedOptions.value,
        allQuestionsRequired: this.testLinkForm.controls.allQuestionsRequired.value,
        trackTelegramUsers: this.testLinkForm.controls.trackTelegramUsers.value
      })
        .then(testLink => this.dialogRef.close(testLink));
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onFinishlessChange(event: MatCheckboxChange): void {
    this.setFinishless(event.checked);
  }

  onMixedQuestionsChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.isMixedQuestions.setValue(event.checked);
  }

  onMixedOptionsChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.isMixedOptions.setValue(event.checked);
  }

  onAllQuestionsRequiredChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.allQuestionsRequired.setValue(event.checked);
  }

  onTrackTelegramUsersChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.trackTelegramUsers.setValue(event.checked);
  }
}
